(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/email-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/email-input.js');
"use strict";


const Email = svs.ui.reactFormInputs.EmailInput;
const EMAIL = svs.ticket_partner.sharedComponents.input.constants.names.EMAIL;
const EmailInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(Email, {
    id: EMAIL,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: "E-postadress",
    name: EMAIL,
    onChange: handleChange,
    value: state[EMAIL]
  });
};
svs.ticket_partner.sharedComponents.input.EmailInput = EmailInput;

 })(window);